import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import * as glosasService from 'services/glosasContabilidad.service'

import * as FormGroups from './formGroups'

const NuevaGlosaModal = ({ handleClose, show, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const submitHandler = async data => {
    await glosasService
      .nuevo(data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha creado.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const formInitialValues = React.useMemo(
    () => ({
      nombre: ''
    }),
    []
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>NUEVA GLOSA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevaGlosaModal
